import { render, staticRenderFns } from "./ReactNestable.vue?vue&type=template&id=5a81617d&scoped=true&"
import script from "./ReactNestable.vue?vue&type=script&lang=js&"
export * from "./ReactNestable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a81617d",
  null
  
)

export default component.exports